import React from 'react'
import styled from 'styled-components'
import P from '../../commons/P'
import {useNavigate} from 'react-router-dom'

const LinkToTrasparenza = () => {
  const navigate = useNavigate()

  return (
    <Container>
      <StyledP>
        Banca Sistema S.p.A. promuove e colloca il prodotto “PrestitoPuoi” nell’ambito di rapporti di collaborazione con istituti finanziari partner, erogatori del finanziamento, con soluzioni che vengono individuate sulla base delle esigenze del cliente. Per informazioni aggiuntive consultare la documentazione di trasparenza disponibile &nbsp;
        <StyledSpan onClick={() => navigate('/trasparenza')}>qui</StyledSpan>
      </StyledP>
    </Container>
  )
}

export default LinkToTrasparenza

// region Style
const Container = styled.div`
  margin: 0 auto 10rem auto;
  max-width: 1095px;
`
const StyledP = styled(P)`
  text-align: left;
`
const StyledA = styled.a`
  cursor: pointer;
  color: #222;
  :hover {
      color: #FCBB00;
  };
`
const StyledSpan = styled.a`
  cursor: pointer;
  //color: #FCBB00;
  color: #222;
  :hover {
      color: #FCBB00;
  };
  text-decoration: underline; 
`
// endregion
